// Per-user, per-browser memory of which tours were finished or dismissed.
// localStorage can be missing or throw (private mode, blocked storage); every
// accessor degrades to "never seen" rather than breaking the app.
const PREFIX = 'xb.tour';
const MUTED = '__muted';

const keyFor = (userId, name) => `${PREFIX}.${userId ?? 'anon'}.${name}`;

const read = (key) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const write = (key, value) => {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Storage unavailable: the tour simply shows again next time.
  }
};

export const TOUR_STATUS = { COMPLETED: 'completed', SKIPPED: 'skipped' };

export const getTourRecord = (userId, tourId) => read(keyFor(userId, tourId));

/** A tour counts as seen only for the version that was seen; bumping a
 * tour's `version` shows it again. */
export const hasSeenTour = (userId, tour) => {
  const record = getTourRecord(userId, tour.id);
  return !!record && record.version === tour.version;
};

export const markTour = (userId, tour, status) =>
  write(keyFor(userId, tour.id), { status, version: tour.version, at: new Date().toISOString() });

export const isTipsMuted = (userId) => read(keyFor(userId, MUTED)) === true;

export const setTipsMuted = (userId, muted) => write(keyFor(userId, MUTED), muted ? true : null);
